import type { MineralInput } from '../domain/entities/Mineral.entity';

/**
 * Real product photos and specs provided by the client on 2026-08-18 (a
 * branded marketing collage, cropped into individual product shots — see
 * apps/website/public/images/minerals/). That same collage revealed a product
 * not previously mentioned in any prior content session: aragonite. It has
 * been added as its own catalog entry and its own MineralCategory
 * ('aragonite') rather than folded into calcite, since the client's own
 * material treats them as two distinct rocks with separate branding.
 *
 * Calcite Powder is listed as its own entry (slug: calcite-powder, same
 * 'calcite' category) rather than a variant of the raw calcite entry --
 * this entity has no concept of "processing stage", and the two have
 * genuinely different specs (the powder has purity/mesh/packaging data,
 * the raw rock does not), so a separate catalog page for each is the
 * closer fit to what the client actually provided.
 *
 * Kaolin has no photo or specs yet and remains a placeholder pending them.
 */
export const mineralsContent: MineralInput[] = [
  {
    id: 'min-calcite',
    name: 'کلسیت',
    slug: 'calcite',
    category: 'calcite',
    description: 'سنگ کلسیت استخراج‌شده از معدن داریوش معدن آذر، به‌صورت خام و پیش از عملیات خردایش و پودرسازی.',
    specifications: [],
    applications: ['[کاربرد سنگ خام کلسیت — placeholder، منتظر دریافت از کارفرما]'],
    images: ['/images/minerals/calcite-1.jpg'],
    seo: { title: 'کلسیت', description: 'سنگ کلسیت استخراج‌شده از معدن داریوش معدن آذر.' }
  },
  {
    id: 'min-calcite-powder',
    name: 'پودر کلسیت',
    slug: 'calcite-powder',
    category: 'calcite',
    description:
      'پودر کلسیت با خلوص (عیار) ۹۷ تا ۹۹ درصد، قابل ارائه در مش‌بندی‌های مختلف؛ با خلوص بالا، سفیدی مطلوب، دانه‌بندی یکنواخت و بدون ناخالصی مضر.',
    specifications: [
      { label: 'خلوص (عیار)', value: '۹۷٪ تا ۹۹٪' },
      { label: 'مش‌بندی‌های قابل ارائه', value: '325، 400، 600، 800، 1250، 2500 مش' },
      { label: 'بسته‌بندی', value: 'کیسه‌های ۲۵ و ۵۰ کیلویی و جامبوبگ' }
    ],
    applications: ['صنایع رنگ', 'صنایع پلاستیک', 'صنایع کاغذ', 'صنایع لاستیک'],
    images: ['/images/minerals/calcite-powder-1.jpg', '/images/minerals/calcite-mesh-chart.jpg'],
    seo: {
      title: 'پودر کلسیت',
      description: 'پودر کلسیت با خلوص ۹۷ تا ۹۹ درصد در مش‌بندی‌های مختلف — مناسب صنایع رنگ، پلاستیک، کاغذ و لاستیک.'
    }
  },
  {
    id: 'min-aragonite',
    name: 'آراگونیت',
    slug: 'aragonite',
    category: 'aragonite',
    description: 'سنگ آراگونیت استخراج‌شده از معدن داریوش معدن آذر.',
    specifications: [],
    applications: ['[کاربرد آراگونیت — placeholder، منتظر دریافت از کارفرما]'],
    images: ['/images/minerals/aragonite-1.jpg'],
    seo: { title: 'آراگونیت', description: 'سنگ آراگونیت استخراج‌شده از معدن داریوش معدن آذر.' }
  },
  {
    id: 'min-kaolin',
    name: 'کائولن',
    slug: 'kaolin',
    category: 'kaolin',
    description: '[توضیح محصول کائولن — در انتظار دریافت از کارفرما]',
    specifications: [{ label: '[مشخصه فنی — placeholder]', value: '[مقدار — placeholder]' }],
    applications: ['[کاربرد — placeholder]'],
    images: ['/images/minerals/placeholder-mineral.svg'],
    seo: { title: 'کائولن', description: '[توضیح سئو — placeholder]' }
  }
];
